import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getGaUserId} from "../tracking_utils/get_ga_user_id";

export const pageviewAlgolytics = delayHit((payload: Object) => hitAlgolytics("views", {...payload, gaId: getGaUserId()}), 2000);
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getGaUserId} from "../tracking_utils/get_ga_user_id";

export const pageviewAlgolytics = delayHit((payload: Object) => hitAlgolytics("views", {...payload, gaId: getGaUserId()}), 2000);
